import { render, staticRenderFns } from "./TaskDescription.vue?vue&type=template&id=46cb580d&scoped=true&"
import script from "./TaskDescription.vue?vue&type=script&lang=js&"
export * from "./TaskDescription.vue?vue&type=script&lang=js&"
import style0 from "./TaskDescription.vue?vue&type=style&index=0&id=46cb580d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb580d",
  null
  
)

export default component.exports